import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '@cpd-app/state';
import { TrackerActions } from '.';
import { PathwayPageUsageInput, VideoUsageInput } from '@cpd-app/generated';
import { selectInterestSurveyTracker } from './tracker.selectors';

@Injectable({
  providedIn: 'root'
})
export class TrackerFacade {
  public interestSurveyTracker$ = this.store.pipe(
    select(selectInterestSurveyTracker)
  );

  constructor(private store: Store<AppState>) {}

  public updateVideoUsage(videoUsage: VideoUsageInput): void {
    this.store.dispatch(TrackerActions.updateVideoUsage({ videoUsage }));
  }

  public saveVideoUsage(): void {
    this.store.dispatch(TrackerActions.saveVideoUsage());
  }

  public saveLocalVideoUsage(): void {
    this.store.dispatch(TrackerActions.saveLocalVideoUsage());
  }

  public reportDownloaded(): void {
    this.store.dispatch(TrackerActions.reportDownloaded());
  }

  public reportShared(): void {
    this.store.dispatch(TrackerActions.reportShared());
  }

  public startInterestsTracking(): void {
    this.store.dispatch(TrackerActions.startInterestsTracking());
  }
  public savePathwayPageUsage(input: PathwayPageUsageInput): void {
    this.store.dispatch(TrackerActions.savePathwayPageUsage({ input }));
  }
}
